import React from 'react';
import { Card, Button } from 'components/ui';
import { 
  ArrowUpTrayIcon, 
  ExclamationTriangleIcon,
  XMarkIcon 
} from '@heroicons/react/24/outline';
import { hasPermission } from 'utils/permissionsUtils';

export const CentralizedUpload = ({ isMobile, onUpload }) => (
  <Card
    className={`${isMobile ? "p-6" : "p-12"} border-2 border-dashed border-gray-300 text-center dark:border-gray-600`}
  >
    <div
      className={`${isMobile ? "h-16 w-16" : "h-24 w-24"} mx-auto mb-6 flex items-center justify-center rounded-full bg-purple-100 dark:bg-purple-900/20`}
    >
      <ArrowUpTrayIcon
        className={`${isMobile ? "h-8 w-8" : "h-12 w-12"} text-purple-600 dark:text-purple-400`}
      />
    </div>
    <h3
      className={`${isMobile ? "text-lg" : "text-2xl"} dark:text-dark-50 mb-3 font-bold text-gray-900`}
    >
      No documents uploaded yet
    </h3>
    <p
      className={`${isMobile ? "text-sm" : "text-base"} dark:text-dark-300 mx-auto mb-8 max-w-md text-gray-500`}
    >
      Get started by uploading your first document. You can upload PDFs,
      images, spreadsheets, and other file types.
    </p>
    {hasPermission("MLLE") ? <Button
      variant="solid"
      color="primary"
      size={isMobile ? "sm" : "md"}
      className="inline-flex items-center"
      onClick={onUpload}
    >
      <ArrowUpTrayIcon className="mr-2 h-5 w-5" />
      Upload Your First Document
    </Button> : null}
  </Card>
);

export const NoResultsFound = ({ isMobile,notAdded=false }) => (
  <Card className={`${isMobile ? "p-6" : "p-12"} text-center`}>
    <div
      className={`${isMobile ? "h-16 w-16" : "h-20 w-20"} mx-auto mb-6 flex items-center justify-center rounded-full bg-yellow-100 dark:bg-yellow-900/20`}
    >
      <ExclamationTriangleIcon
        className={`${isMobile ? "h-8 w-8" : "h-10 w-10"} text-yellow-600 dark:text-yellow-400`}
      />
    </div>
    <h3
      className={`${isMobile ? "text-lg" : "text-xl"} dark:text-dark-50 mb-3 font-bold text-gray-900`}
    >
      {notAdded ? "No documents found." : "No documents match your filters"}
    </h3>
    <p
      className={`${isMobile ? "text-sm" : "text-base"} dark:text-dark-300 mx-auto mb-6 max-w-md text-gray-500`}
    >
      {notAdded ? "" : "Try adjusting your search criteria or clear the filters to see all documents."}
      
    </p>
    
  </Card>
);

export const LoadingState = () => (
  <Card className="p-8 text-center">
    <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-4 border-primary-200 border-t-primary-600" />
    <p className="dark:text-dark-400 text-gray-500">Loading documents...</p>
  </Card>
);
